import { httpClient } from './http-client';
import { Blog } from './types';
import { BlogPost } from '@/types/blog.types';

export const blogService = {
  /**
   * Get all blogs
   */
  async getAllBlogs(): Promise<BlogPost[]> {
    const rawBlogs = await httpClient.get<Blog[]>('/api/v1/blogs');
    return rawBlogs.map(mapBlogToFrontend);
  },

  /**
   * Get a single blog by slug
   */
  async getBySlug(slug: string): Promise<BlogPost | null> {
    const allBlogs = await this.getAllBlogs();
    return allBlogs.find(b => b.slug === slug) || null;
  }
};

function mapBlogToFrontend(blog: any): BlogPost {
  // Check where slug is located. It is inside seo object in the model.
  const slug = blog.seo?.slug || blog.slug || blog._id;

  return {
    id: blog._id,
    slug: slug,
    title: blog.title,
    excerpt: blog.content ? blog.content.substring(0, 150) + '...' : '',
    content: blog.content,
    category: typeof blog.categoryId === 'object' && blog.categoryId !== null
      ? (blog.categoryId as any).categoryName
      : 'Uncategorized',
    author: blog.author,
    date: blog.publishedDate,
    image: blog.featuredImage || '/placeholder.jpg',
    readTime: 5, // Placeholder
  };
}
